module.exports = __webpack_public_path__ + "img/logo-qtt.98813c57.png";